import type { IconName } from "@similarweb/icons";

import type { IUserKeywordGroup } from "app/services/keyword-groups";
import { keywordGroupsQueryClient, KEYWORD_GROUP_PREFIX } from "app/services/keyword-groups";

export class KeywordsGroupUtilities {
    private static KEYWORDS_GROUP_DEFAULT_ICON: IconName = "keyword-group";

    private static KEYWORDS_DEFAULT_ICON: IconName = "search-keywords";

    static getGroupNameById = async (groupId: any): Promise<string | undefined> => {
        const group = await KeywordsGroupUtilities.getGroupById(groupId);
        return group?.Name;
    };

    static getGroupById = async (groupId: any): Promise<IUserKeywordGroup | undefined> => {
        const groups = await KeywordsGroupUtilities.getUserKeyWordsGroup();
        return groups.find(({ Id }) => Id === groupId);
    };

    static getGroupByName = async (groupName: string): Promise<IUserKeywordGroup | undefined> => {
        const groups = await KeywordsGroupUtilities.getUserKeyWordsGroup();
        return groups.find(({ Name }) => Name.toLowerCase() === groupName.toLowerCase());
    };

    static getUserGroupByName = async (groupName: string): Promise<IUserKeywordGroup | undefined> => {
        const groups = await keywordGroupsQueryClient.getUserGroups();
        return groups.find(({ Name }) => Name.toLowerCase() === groupName.toLowerCase());
    };

    static getUserKeyWordsGroup = async (): Promise<IUserKeywordGroup[]> => {
        try {
            const { userGroups, sharedGroups } = await keywordGroupsQueryClient.getAllGroups();
            return [...userGroups, ...sharedGroups];
        } catch {
            return [];
        }
    };

    static getKeywordsGroupDefaultIcon = (): IconName => KeywordsGroupUtilities.KEYWORDS_GROUP_DEFAULT_ICON;

    static getKeywordsDefaultIcon = (): IconName => KeywordsGroupUtilities.KEYWORDS_DEFAULT_ICON;

    static isKeywordsGroupByName = (termName: string): boolean => termName?.startsWith(KEYWORD_GROUP_PREFIX);
}
